import React from 'react';
import ProductListView from './ProductList.view';
import { ProductTypes } from '../../../../types/product/product';

export interface ProductItemProps {
  product: ProductTypes;
  setProductQuantity: (n: number) => void;
  onAddToCart: () => void;
  onClickNavigate: () => void;
  isPublicShop?: boolean;
}

/* isOut à ajouter par la suite quand le back sera prêt */
const ProductList = ({
  product,
  setProductQuantity,
  onAddToCart,
  onClickNavigate,
  isPublicShop = false
}: ProductItemProps) => {
  return (
    <ProductListView
      product={product}
      setProductQuantity={setProductQuantity}
      onAddToCart={onAddToCart}
      onClick={onClickNavigate}
      isOut={product.isOut}
      isPublicShop={isPublicShop}
    />
  );
};

export default ProductList;
